// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1gkJ9","addWidgetButton":"Header_addWidgetButton__1qlHd","dashboardTabs":"Header_dashboardTabs__38BkJ","active":"Header_active__1sJfF"};